import type JobGanttChartStore from "./JobGanttChartStore";
import { RouteType } from "types/RouteType";

const jobGanttChartRoute: RouteType[] = [
  {
    name: "Job Gantt Chart",
    path: "/job/:jobNumber/gantt-chart",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Job Schedule - Gantt Chart",
        enableToolbox: true,
        enableBackButton: true,
        enableRefreshButton: true,
      },
      body: {
        component: () => import("./JobGanttChart.Body"),
        grayBackground: true,
      },
    },
    group: "Project Management",
    requiresAuth: true,
    requiresPermission: false,
    projectRoute: true,
    channels: [
      "job-schedule/:jobNumber",
      "panel/:jobNumber",
    ],
    enableAutoFind: false,
    beforeEnter: async ({ params, rootStore }) => {
      console.log(
        "🔍 JobGanttChart beforeEnter called with job:",
        params?.jobNumber
      );

      const jobGanttChartStore =
        rootStore?.jobGanttChartStore as JobGanttChartStore;

      if (jobGanttChartStore && params?.jobNumber) {
        await jobGanttChartStore.loadJobScheduleData(
          params.jobNumber as string
        );
      }

      return true;
    },
    onParamsChange: async ({
      rootStore,
      queryParams,
      previousQueryParams,
      params,
    }) => {
      console.log(
        "🔄 JobGanttChart onParamsChange called for job:",
        params?.jobNumber
      );

      // Skip side effects when opening/closing dialogs
      if (
        queryParams?.dialogName ||
        (!queryParams?.dialogName && previousQueryParams?.dialogName)
      ) {
        return;
      }

      // Refresh data when job number changes
      const jobGanttChartStore =
        rootStore?.jobGanttChartStore as JobGanttChartStore;

      if (jobGanttChartStore && params?.jobNumber) {
        await jobGanttChartStore.loadJobScheduleData(
          params.jobNumber as string
        );
      }
    },
  },
];

export default jobGanttChartRoute;